<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="Manage the spaces for this brand."/>
    <span class="inline-block max-w-lg text-light mb-4">A space works like a separate workspace — a different business, department or location, each with its own survey and collaborators.</span>
    <div v-if="!$store.getters['dash/subscription'].isTrial">
    <div v-if="multiLocations.length > 0">
      <div class="w-full">
        <p>
          <vs-button v-if="multiLocations.length <= $store.getters['dash/numberOfMultisAllowed']" class="w-full lg:w-64 mt-3 lg:mt-0 lg:float-right lg:mr-1" icon-pack="feather" icon-after icon="icon-plus" @click="
          () => {
              this.$store.commit('LOAD_ADDNEW_STATE')
              this.$store.commit('signUpState/RESET_SIGNUP_STATE')
              this.$router.push('/dash/addnew')
          }">Add Space</vs-button>
          <vs-input class="w-full lg:w-100 mt-3 lg:mt-0 lg:float-left" placeholder="Filter spaces by name..." v-model="locationFilter"/>
        </p>
      </div>
      <div class="vx-row md:py-4 mt-10 clear-both">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base flex" v-for="(location,i) in multiLocations" v-if="location.businessName.toLowerCase().indexOf(locationFilter.toLowerCase()) !== -1">
          <vx-card :title="location.businessName"   >
            <template slot="actions">
              <small class="flex cursor-pointer" @click="() => {
                showSureRemoveLocation = true
                currentLocationToRemove = location.i
                }">
                <feather-icon :class="{'hidden': i === 0}" icon="Trash2Icon" svgClasses="w-6 h-6 text-grey"></feather-icon>
              </small>
            </template>
            <div class="text-center">
              <a class="mt-2 text-primary" target="_blank" :href="'https://feedback.link/' + location.feedbackAddressHandle + '?istest=true'">feedback.link/{{location.feedbackAddressHandle}} <feather-icon icon="ExternalLinkIcon" svgClasses="w-4 h-4 text-primary"></feather-icon></a>
            </div>
            <vs-divider/>
            <div v-if="location.npsData">
            <div class="vx-row my-8" v-if="location.npsData.npsTotal === false">
              <div class="text-center font-medium text-light block my-6 mx-auto" v-if="location.npsData.npsTotal === false">Waiting for feedback...</div>
            </div>
            <div v-else>
            <div class="text-center text-light block">Net Promoter Score</div>
            <div class="vx-row my-2">
              <div class="vx-col text-center w-1/3">
                <span class="font-bold text-3xl" :class="{'text-danger': location.npsData.npsTotal < 0, 'text-warning': location.npsData.npsTotal >= 0 && location.npsData.npsTotal < 10, 'text-success': location.npsData.npsTotal > 9}">{{location.npsData.npsTotal}}</span>
                <p class="text-sm text-light">Overall</p>
              </div>
              <div class="vx-col text-center w-1/3">
                <span class="font-bold text-3xl" :class="{'text-danger': location.npsData.nps7 < 0, 'text-warning': location.npsData.nps7 >= 0 && location.npsData.nps7 < 10, 'text-success': location.npsData.nps7 > 9}">{{location.npsData.nps7}}</span>
                <p class="text-sm text-light">Last 7 Days</p>
              </div>
              <div class="vx-col text-center w-1/3">
                <span class="font-bold text-3xl" :class="{'text-danger': location.npsData.nps30 < 0, 'text-warning': location.npsData.nps30 >= 0 && location.npsData.nps30 < 10, 'text-success': location.npsData.nps30 > 9}">{{location.npsData.nps30}}</span>
                <p class="text-sm text-light">Last 30 Days</p>
              </div>
            </div>
            </div>
            </div>
            <vs-button type="line" size="large" @click="() => {
              showChangeLocation = false
              callChangeLocation(i)
              if (showCloseButton) {
                $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
              }
              $router.push('/dash/home')
              }" icon-pack="feather" icon="icon-arrow-right" icon-after class="w-full mt-3" >View</vs-button>
          </vx-card>
        </div>
      </div>
      <vs-popup class="holamundo" title="Remove space" :active.sync="showSureRemoveLocation" @close="iDontWantToRemoveLocation">
        <div class="con-vs-alert mt-3 con-vs-alert-danger">
          <h4 class="titlex vs-alert--title">Warning</h4>
          <div class="vs-alert text-lg">
          If you remove this space, you will lose all data, feedback and accounts associated with it!
        </div>
        </div>
        <vs-divider class="my-4"/>
        <p v-if="currentLocationToRemove !== false" class="text-lg mb-2">If you're sure you want to remove the space <span class="font-medium text-xl">{{ multiLocations[currentLocationToRemove].businessName }}</span>, please type 'remove' in the below textbox.</p>
        <vs-input placeholder="Type 'remove' to continue." v-model="removeText"/>
        <div class="overflow-auto mt-4">
          <vs-button class="float-right ml-1" @click="removeLocation(multiLocations[currentLocationToRemove].businessID)" :disabled="removeText !== 'remove'">Remove</vs-button>
          <vs-button type="border" class="float-right" @click="iDontWantToRemoveLocation">Cancel</vs-button>
        </div>
      </vs-popup>
    </div>
    <div v-else class="text-center">
      <div class="inline-block w-132 my-20">
        <img class="mx-auto w-32" src="@/assets/images/misc/target.png"/>
        <p class="my-8 font-medium text-lg" >No other spaces for this brand.</p>
        <vs-button class="w-full" @click="
        () => {
            this.$store.commit('LOAD_ADDNEW_STATE')
            this.$store.commit('signUpState/RESET_SIGNUP_STATE')
            this.$router.push('/dash/addnew')
        }">Add Space</vs-button>
      </div>
    </div>
  </div>
  <div v-else class="text-center">
    <div class="inline-block w-132 my-20">
      <img class="mx-auto w-32" src="@/assets/images/misc/target.png"/>
      <p class="my-8 font-medium text-lg">Your current plan doesn't support multiple spaces.</p>
      <vs-button class="w-full" type="border" @click="$router.push('/dash/settings/plan')">Upgrade Plan</vs-button>
    </div>
  </div>
</div>
</template>


<script>

import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'
import { changeCurrentLocation } from '../methods/changeCurrentLocation'

export default {
  data () {
    return {
      locationFilter: '',
      removeText: '',
      showSureRemoveLocation: false,
      currentLocationToRemove: false,
    }
  },
  computed: {
    showChangeLocation: {
      get () {
        return this.$store.state.dash.showChangeLocation
      },
      set (v) {
        this.$store.commit('dash/TOGGLE_SELECT_LOCATION', v)
      }
    },
    selectedMultiLocation: {
      get () {
        return this.$store.state.dash.currentMultiLocationI
      },
      set (v) {
        changeCurrentLocation(v)        
      }
    },
    multiLocations () {
      if (this.$store.state.dash.isMulti && this.$store.state.dash.allEntitiesLoaded) {
        return this.$store.state.dash.multiLocations
      } else {
        return []
      }
    },
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  methods: {
    callChangeLocation(i) {
      changeCurrentLocation(i)        
    },
    removeLocation(uid) {

      let removeDetail = {
        locationUID: uid
      }

      if (typeof this.$store.state.dash.viewData.business.agencyParent !== 'undefined') {
        //we're removing a location for the client
        if (this.$store.getters['dash/agency'].isClientName) {
          //noconsoleconsole.log('removing client')
          removeDetail.isClientLocation = this.$store.getters['dash/agency'].clientAuthDoc.clientID
        } else {
          this.$vs.dialog({
            color: 'dark',
            acceptText: 'Ok',
            title: `Oh no!`,
            text: 'We couldn\'t remove your space. Please try again, or reach out to support with the code \'rcl\' - support@feedback.link'
          })
          return
        }
      } else {
        if (this.$store.getters['dash/agency'].isClientName) {
            //something wrong, don't continue
            this.$vs.dialog({
              color: 'dark',
              acceptText: 'Ok',
              title: `Oh no!`,
              text: 'We couldn\'t remove your space. Please try again, or reach out to support with the code \'rcl\' - support@feedback.link'
            })
            return
        }
      }

      //noconsoleconsole.log(removeDetail)


      this.$vs.loading()
      this.$store.dispatch('dash/REMOVE_MULTI_LOCATION', removeDetail).then((res) => {
        //noconsoleconsole.log(res)
        if (typeof res.data.error !== 'undefined') {
          this.$vs.notify({
            title:'Remove Space',
            time: 10000,
            text:'Oops! Something went wrong, and we couldn\'t remove this space. Please try again, and please notify support if it happens again: support@feedback.link',
            color:'warning',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else {
          this.$vs.notify({
            title:'Remove Space',
            text:'Space removed successfully',
            color:'success',
            time: 8000,
            iconPack: 'feather',
            icon:'icon-check'})
            let url = window.location.href
            let arr = url.split("/");
            window.location.href = arr[0] + '//' + arr[2] + '/dash/home'
        }

        this.$vs.loading.close()

      }).catch(() => {
        this.$vs.notify({
          title:'Remove Space',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t remove this space. Please try again, and please notify support if it happens again: support@feedback.link',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
          this.$vs.loading.close()
      })

    },
    iDontWantToRemoveLocation () {
      this.removeText = ''
      this.showSureRemoveLocation = false
      this.currentLocationToRemove = false
    },
    addNewLocation () {

      setTimeout(()=>{
        this.$store.commit('LOAD_ADDNEW_STATE')
        this.$store.commit('signUpState/RESET_SIGNUP_STATE')
        this.$router.push('/dash/addnew')
      }, 1)

      this.$store.commit('dash/TOGGLE_SELECT_LOCATION', false)

    }
  },
  created () {

  },
  watch: {

  }
}
</script>

<style lang="scss">

</style>
